/* eslint-disable */

import { ArrowLeft, Check, X, Clock, RefreshCw, Info } from 'lucide-react'
import { Dialog, DialogContent } from '../../Components/ui/dialog'
import { Button } from '../../Components/ui/button'
import { cn } from '../../lib/utils'

const PaymentStatusModal = ({
  isOpen = false,
  onClose,
  onContinue,
  onRetry,
  status = 'inprogress',
  loading = false,
  paymentData,
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'success':
        return {
          icon: Check,
          iconBg: 'bg-green-500',
          cardBg: 'bg-green-50 dark:bg-green-950/20',
          title: 'Payment Successful',
          description: 'Your payment has been completed successfully',
          statusText: 'Completed',
          statusColor: 'text-green-600 dark:text-green-400',
          statusDot: 'bg-green-500',
          infoText:
            'Your payment has been processed successfully. Allocation will be done in 2-5 days based on funds.',
          showRetry: false,
          showComplete: false,
        }
      case 'failure':
        return {
          icon: X,
          iconBg: 'bg-error-500',
          cardBg: 'bg-error-50 dark:bg-error-950/20',
          title: 'Payment Failed',
          description: 'Your payment could not be processed',
          statusText: 'Failed',
          statusColor: 'text-error-600 dark:text-error-400',
          statusDot: 'bg-error-500',
          infoText:
            'Your payment could not be processed. Please check your payment details and try again.',
          showRetry: true,
          showComplete: false,
        }
      default: // inprogress
        return {
          icon: Clock,
          iconBg: 'bg-warning-500',
          cardBg: 'bg-warning-50 dark:bg-warning-950/20',
          title: 'Payment Processing',
          description: paymentData?.paymentMode?.includes('Cheque') || paymentData?.paymentMode?.includes('OTM') ? (
            'Your order is being processed.'
          ) : (
            <>
              Awaiting confirmation from your bank.
              <br />
              Payments may take 1-2 hrs to reflect.
            </>
          ),
          statusText: 'In Progress',
          statusColor: 'text-warning-600 dark:text-warning-400',
          statusDot: 'bg-warning-500',
          infoText: paymentData?.paymentMode?.includes('OTM') ? 'Your money will be debited automatically within the next 2 working days.' : paymentData?.paymentMode?.includes('Cheque') ? (
            'Your Relationship Manager will stay in touch with you. '
          ) : (
            <>
              Your money is safe 😊
              <br /> <span>Please retry if your payment was unsuccessful.</span>
            </>
          ),
          showRetry: paymentData?.paymentMode?.includes('Cheque') ? false : true,
          showComplete: true,
        }
    }
  }

  const config = getStatusConfig()
  const IconComponent = config.icon

  const handleAction = (action) => {
    if (typeof action === 'string') {
      // If action is a URL string, navigate to it
      window.location.href = action
    } else if (typeof action === 'function') {
      // If action is a function, execute it
      action()
    }
  }

  const handleRetry = () => {
    handleAction(onRetry)
  }

  const handleComplete = () => {
    handleAction(onContinue)
  }

  const handleClose = () => {
    handleAction(onClose)
  }

  if (!isOpen) return null

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className='sm:max-w-md w-full h-full sm:h-auto max-h-screen overflow-y-auto p-0 gap-0'>
        <div className='flex flex-col h-full'>
          {/* Header */}
          <div className='flex items-center gap-4 p-4 border-b'>
            {/* <Button variant='ghost' size='icon' onClick={handleClose} className='h-8 w-8'>
              <ArrowLeft className='h-4 w-4' />
            </Button> */}
            <h2 className='text-lg font-semibold'>Payment Status</h2>
          </div>

          {/* Content */}
          <div className='flex-1 p-6 space-y-6'>
            {/* Status Card */}
            <div className={cn('rounded-lg p-6 text-center', config.cardBg)}>
              <div
                className={cn(
                  'w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4',
                  config.iconBg,
                )}
              >
                <IconComponent className='h-8 w-8 text-white' />
              </div>
              <h3 className='text-xl font-semibold mb-2 text-foreground'>{config.title}</h3>
              <p className='text-muted-foreground text-sm'>{config.description}</p>
            </div>

            {/* Investment Details */}
            <div className='space-y-4'>
              <h4 className='text-lg font-semibold'>Investment Details</h4>

              <div className='space-y-3'>
                <div className='flex justify-between items-center'>
                  <span className='text-muted-foreground'>Investment Amount</span>
                  <span className='font-semibold'>₹ {paymentData.amount}</span>
                </div>

                <div className='flex justify-between items-center'>
                  <span className='text-muted-foreground'>Status</span>
                  <div className='flex items-center gap-2'>
                    <div className={cn('w-2 h-2 rounded-full', config.statusDot)} />
                    <span className={cn('font-medium', config.statusColor)}>
                      {config.statusText}
                    </span>
                  </div>
                </div>

                <div className='flex justify-between items-center'>
                  <span className='text-muted-foreground'>Payment Mode</span>
                  <span className='font-semibold'>{paymentData.paymentMode}</span>
                </div>

                {/* <div className='flex justify-between items-center'>
                  <span className='text-muted-foreground'>Date & Time</span>
                  <span className='text-sm'>{paymentData.date}</span>
                </div> */}
              </div>
            </div>

            {/* More Information */}
            <div className='bg-blue-50 dark:bg-blue-950/20 rounded-lg p-4'>
              <div className='flex items-start gap-3'>
                <Info className='h-5 w-5 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0' />
                <div className='space-y-2'>
                  <h5 className='font-medium text-blue-900 dark:text-blue-100'>More Information</h5>
                  <p className='text-sm text-blue-700 dark:text-blue-300'>{config.infoText}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className='p-6 pt-0 space-y-3'>
            {config.showRetry && (
              <Button variant='outline' className='w-full' onClick={handleRetry} disabled={loading}>
                <RefreshCw className={`h-4 w-4 mr-2 ${loading ? 'animate-spin' : ''}`} />
                Retry Payment
              </Button>
            )}

            {config.showComplete && (
              <Button className='w-full' onClick={handleComplete}>
                <Check className='h-4 w-4 mr-2' />
                {paymentData?.paymentMode?.includes('Cheque')
                  ? 'Order Completed'
                  : 'Payment Completed'}
              </Button>
            )}

            {status === 'success' && (
              <Button className='w-full' onClick={() => handleAction(onContinue)}>
                <Check className='h-4 w-4 mr-2' />
                Done
              </Button>
            )}

            {status === 'failure' && (
              <Button variant='outline' className='w-full bg-transparent' onClick={handleClose}>
                Close
              </Button>
            )}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}

// Export the main component for direct usage
export default PaymentStatusModal
